















































































import { Component, Vue, Prop } from "vue-property-decorator";
import VerEx from "verbal-expressions";
import { ProductFormData } from "@/interfaces";
import dayjs from "dayjs";
import { ProductInfo } from "@/api";
import { FormState } from "@/constant";

@Component
export default class Form extends Vue {
  @Prop() productInfo: ProductInfo | undefined;

  mobileNo = "";
  name = "";
  birthDate = "";
  lineId = "";
  sex = "";
  sexChoice = [
    { state: "ชาย", key: "M" },
    { state: "หญิง", key: "F" }
  ];

  isDateModalOpen = false;

  isRequired(state?: string) {
    return FormState.MANDATORY === state;
  }

  isNeeded(state?: string) {
    return FormState.NOPE !== state;
  }

  phoneNumberRules = [
    (v: string) => !!v || "Phone number is required",
    (v: string) =>
      VerEx()
        .startOfLine()
        .find("0")
        .digit()
        .multiple()
        .endOfLine()
        .test(v) || "Phone number is not correct",
    (v: string) => v.length === 10 || "Phone number must be 10 digits"
  ];
  nameRules = [
    (v: string) =>
      !this.isRequired(this.productInfo?.nameRegister) ||
      !!v ||
      "Name is required"
  ];
  birthDateRules = [
    (v: string) =>
      !this.isRequired(this.productInfo?.birthRegister) ||
      !!v ||
      "Date is required",
    (v: string) =>
      dayjs(new Date()).diff(dayjs(v), "year") >= 10 ||
      "Age must be older than 10"
  ];
  lineIDRules = [
    (v: string) =>
      !this.isRequired(this.productInfo?.lineRegister) ||
      !!v ||
      "Line ID is required"
  ];
  sexRules = [
    (v: string) =>
      !this.isRequired(this.productInfo?.sexRegister) ||
      !!v ||
      "Sex is required"
  ];
  valid = false;

  submit() {
    const data: ProductFormData = {
      mobileNo: this.mobileNo,
      name: this.name,
      birthDate: this.birthDate,
      lineId: this.lineId,
      sex: this.sex
    };
    this.$emit("submit", data);
  }
}
